module.exports = __webpack_public_path__ + "c72290bc6b1ae3994b14fd1d367e528b.svg";